import React from 'react'
import { sumatoryPrices } from '../../../../utils/functions'

const TransferDetaillView = ({ products }) => {
    return (
        <div>
            <table>
                <thead>
                    <tr>
                        <th>Codigo</th>
                        <th>Nombre</th>
                        <th>Lote</th>
                        <th>Precio unitario</th>
                        <th>Cantidad</th>
                        <th>SubTotal</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        products.map(product => (
                            <tr key={product._id}>
                                <td>{product.code}</td>
                                <td>{product.name}</td>
                                <td>{product.batch}</td>
                                <td>{product.unit_price}</td>
                                <td>{product.quantity}</td>
                                <td>{product.quantity * product.unit_price}</td>
                            </tr>
                        ))
                    }
                </tbody>
                <tfoot>
                    <tr>
                        <th>Total:{sumatoryPrices(products)}</th>
                    </tr>
                </tfoot>
            </table>
        </div>
    )
}

export default TransferDetaillView
